const languages = process.env.GATSBY_LANGUAGES.split(",") || [
  "en",
  "pl",
  "es",
  "de",
  "fr",
  "nl",
  "ro",
  "bg",
  "hu",
  "it",
  "gr",
]
const defaultLanguage = process.env.GATSBY_DEFAULT_LANGUAGE || "en"

const LANGUAGES_WITH_LABELS = [
  {
    label: "English",
    value: defaultLanguage === "en" ? "" : "en",
  },
  {
    label: "Polski",
    value: defaultLanguage === "pl" ? "" : "pl",
  },
  {
    label: "Español",
    value: defaultLanguage === "es" ? "" : "es",
  },
  {
    label: "Deutsch",
    value: defaultLanguage === "de" ? "" : "de",
  },
  {
    label: "Français",
    value: defaultLanguage === "fr" ? "" : "fr",
  },
  {
    label: "Nederlands",
    value: defaultLanguage === "nl" ? "" : "nl",
  },
  {
    label: "Română",
    value: defaultLanguage === "ro" ? "" : "ro",
  },
  {
    label: "Български",
    value: defaultLanguage === "bg" ? "" : "bg",
  },
  {
    label: "Magyar",
    value: defaultLanguage === "hu" ? "" : "hu",
  },
  {
    label: "Italiano",
    value: defaultLanguage === "it" ? "" : "it",
  },
  {
    label: "Ελληνικά",
    value: defaultLanguage === "gr" ? "" : "gr",
  },
].filter(
  language => languages.includes(language.value) || language.value === "",
)
const COUNTRY_LANGUAGE_AND_CODE = {
  pl: "pl-PL", // Mapping Polish to Poland
  en: "en-GB", // Mapping English to United Kingdom
  es: "es-ES", // Mapping Spanish to Spain
  de: "de-DE", // Mapping German to Germany
  fr: "fr-FR", // Mapping French to France
  nl: "nl-NL", // Mapping Dutch to Netherlands
  ro: "ro-RO", // Mapping Romanian to Romania
  bg: "bg-BG", // Mapping Bulgarian to Bulgaria
  hu: "hu-HU", // Mapping Hungarian to Hungary
  it: "it-IT", // Mapping Italian to Italy
  gr: "el-GR", // Mapping Greek to Greece
}
const COUNTRY_NAME_FROM_LANGUAGE_KEY = {
  pl: "Polish",
  en: "English",
  es: "Spanish",
  de: "German",
  fr: "French",
  nl: "Dutch",
  ro: "Romanian",
  bg: "Bulgarian",
  hu: "Hungarian",
  it: "Italian",
  gr: "Greek",
}

module.exports = {
  languages,
  defaultLanguage,
  LANGUAGES_WITH_LABELS,
  COUNTRY_LANGUAGE_AND_CODE,
  COUNTRY_NAME_FROM_LANGUAGE_KEY,
}
